/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LogOutIcon = ({ width = 24, height = 24, hidden = false, title = 'Log Out' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="18" rx="1" ry="1" width="4" x="16" />
    <path
      d="m25.215 5.063-1.14 1.823a1.01 1.01 0 0 0 .337 1.384 11.738 11.738 0 1 1-12.82 0 1 1 0 0 0 .336-1.377l-1.144-1.831A1 1 0 0 0 9.4 4.731a15.9 15.9 0 1 0 17.191 0 1 1 0 0 0-1.376.332Z"
    />
  </svg>`;
};
